// region: Imports

import { Tab, Modal, Collapse, Dropdown } from 'bootstrap';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import './video-popups';
import './Components/Select';
import './Components/AudioPlayer';
import { setupLottieAnimations } from './module-lottie-intersection';
// endregion: Imports


// Rufe die Funktion zum Einrichten der Lottie-Animationen auf
setupLottieAnimations();

//
// Functions
//

var searchTimeoutId;
var searchSuggestions;

function initSearchSuggest() {

  /** solr search autocomplete **/
  //suche?type=7384&tx_solr[queryString]=test
  $('.search-box-container-close').click(function(){
    $('.search-box-container').fadeOut('fast');
    $('body').removeClass('no-scroll');
  });

  $('.show-page-search').click(function(){
    closeMenu();
    $('.search-box-container').fadeIn('fast');
    $('body').addClass('no-scroll');
  });
/*
  $('#tx-solr-q-field').on('input', function() {
    console.log('hier')
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(function() {
      $.getJSON({
        url: '/suche?type=7384&tx_solr[queryString]=' + $('#tx-solr-q-field').val(),
        data: {},
        success: function(response) {
          console.log(response)
          if (response.suggestions) {
            showSuggestions(response.suggestions);
            $('#tx-solr-search-form-pi-results-modal').addClass('suggestion-list-is-open');
          }
        }
      });
    }, 500);

  });
  */




}











// Funktion zur Berechnung und Anpassung der Dropdown-Menühöhe und Position
function adjustDropdown(inputField, dropdownMenu) {
  const inputFieldRect = inputField.getBoundingClientRect();
  const screenHeight = window.innerHeight;
  const maxHeight = screenHeight - inputFieldRect.bottom - 10; // Füge etwas Puffer hinzu

  if (maxHeight >= dropdownMenu.scrollHeight) {
    // Zeige das Dropdown unten an
  } else {
    // Zeige das Dropdown oben an und ändere die Position beim Scrollen
    //dropdownMenu.style.top = `${inputFieldRect.top - dropdownMenu.scrollHeight - 10}px`;
  }

  dropdownMenu.style.maxHeight = `${maxHeight}px`;
}

document.addEventListener("DOMContentLoaded", function() {
  let inputFields = document.querySelectorAll('.tx-solr-suggest');

  inputFields.forEach(inputField => {
    let dropdownMenu = inputField.parentElement.querySelector('.dropdown-menu');


    // dropdownMenu.style.display = 'none'; // Verstecke das Dropdown-Menü zu Beginn

    inputField.addEventListener('input', function() {
      let term = inputField.value;

      if (term.length >= 3) {
        fetch(`/suche?type=7384&tx_solr[queryString]=${encodeURIComponent(term)}`)
          .then(response => response.json())
          .then(data => {
            const suggestions = data.suggestions || [];

            // Entferne alte Einträge
            dropdownMenu.innerHTML = '';

            const suggestionArray = Object.entries(suggestions);

            if (suggestionArray.length > 0) {
              // Iteriere über die Schlüssel-Wert-Paare und füge neue Einträge hinzu
              suggestionArray.forEach(([key, value]) => {
                const suggestionItem = document.createElement('a');
                suggestionItem.classList.add('dropdown-item');
                suggestionItem.href = `/suche?tx_solr[q]=${encodeURIComponent(key)}`;
                suggestionItem.textContent = key; // Verwende den Schlüssel als Anzeigetext
                dropdownMenu.appendChild(suggestionItem);
              });

              // Zeige das Dropdown-Menü an
              // dropdownMenu.style.display = 'block';

              // Passe die Position und maximale Höhe an
              adjustDropdown(inputField, dropdownMenu);
            } else {
              // Verstecke das Dropdown-Menü, wenn keine Vorschläge vorhanden sind
              // dropdownMenu.style.display = 'none';
            }

          })
          .catch(error => {
            console.error('Fehler beim Abrufen von Vorschlägen:', error);
          });
      } else {
        // Verstecke das Dropdown-Menü, wenn weniger als 3 Zeichen eingegeben wurden
        // dropdownMenu.style.display = 'none';
      }
    });

    // Verstecke das Dropdown-Menü und entferne die Position bei Blur
    inputField.addEventListener('blur', function() {
      // dropdownMenu.style.display = 'none';
    });

    // Verstecke das Dropdown-Menü und entferne die Position bei Blur
    inputField.addEventListener('focus', function() {
      // dropdownMenu.style.display = 'none';

    });
  });

  // Optimierte Fenstergrößenänderungs-Funktion mit Timeout
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      inputFields.forEach(inputField => {
        const dropdownMenu = inputField.parentElement.querySelector('.dropdown-menu');
        adjustDropdown(inputField, dropdownMenu);
      });
    }, 100); // Warte 100ms, bevor die Funktion aufgerufen wird
  });

});










/*
document.addEventListener("DOMContentLoaded", function() {
  const inputField = document.getElementById('tx-solr-suggest');

  inputField.addEventListener('input', function() {
    const term = inputField.value;

    if (term.length >= 3) {
      fetch(`/suche?type=7384&tx_solr[queryString]=${encodeURIComponent(term)}`)
        .then(response => response.json())
        .then(data => {
          const suggestions = data.suggestions || [];
          if (suggestions) {
            //showSuggestions(suggestions);
            //$('#tx-solr-search-form-pi-results-modal').addClass('suggestion-list-is-open');
          }

          // Anzeige der Vorschläge
          // Hier kannst du die Vorschläge in ein Dropdown oder ähnliches einfügen
          // Zum Beispiel könntest du eine <ul> Liste erstellen
        })
        .catch(error => {
          console.error('Error fetching suggestions:', error);
        });
    }
  });



  const dropdownMenu = document.getElementById('autocompleteDropdown');

  inputField.addEventListener('input', function() {
    const inputValue = inputField.value.toLowerCase();
    const items = dropdownMenu.getElementsByClassName('dropdown-item');

    for (const item of items) {
      const itemText = item.innerText.toLowerCase();
      if (itemText.includes(inputValue)) {
        // item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    }

    dropdownMenu.classList.add('show');
  });

});
*/

  function showSuggestions(suggestions) {
  var words = Object.keys(suggestions);

  const $list = $('#suggestion-list-ul');
  $list.empty();

// Durchlaufe das Array und erstelle für jeden String ein <li> Element
  words.forEach(function(item) {
    const $li = $('<li>').text(item);
    $list.append($li);
  });

  $('#suggestion-list-ul li').on('click', function() {
    window.location = '/suche?tx_solr[q]=' + $(this).html();
  })
}


function initTabMenu(classNames) {
    if ($(classNames).length) {
        return import(/* webpackChunkName: "module-tabMenu" */ './module-tabMenu').catch(err => console.error(err));
    }
}

function initDirectPopups(classNames) {
    let $objs = $(classNames);
    if ($objs.length) {

        $objs.modal('show');

    }
}

function initScrollDownBtn() {
    $(document).on('click', ".scroll-down-link", function(e) {
        e.preventDefault();
        $('html,body').stop().animate({scrollTop:$($(this).attr('href')).offset().top}, 300, 'swing', function() {

        });
    });
}

function initMenuToggle() {
    $(document).on('click', '[data-ariatoggle="#page-menu"],[data-ariatoggle="#page-mobile-menu"]', function (e) {
        e.preventDefault();

        let $target = $($(this).attr('data-ariatoggle'));

        $target.attr('aria-expanded', ($target.attr('aria-expanded') === 'true' ? 'false' : 'true'));

        if ($(this).attr('data-ariatoggle') === '#page-mobile-menu') {
            $('body').toggleClass('noscroll-mobile-nav');
        }
    });
}



function initCookieBanner() {
    return import(/* webpackChunkName: "module-cookieBanner" */ './module-cookieBanner').catch(err => console.error(err));
}



function closeMenu() {
  $('#page-menu').removeClass('show');
  $('body').removeClass('disable-body');
}

function initOffCanvasNav(selector) {
  if ($(selector).length) {

    $(document).on('click', '[data-bd-trigger="close-menu"]', function(e) {
      e.preventDefault();
      closeMenu()
    });


    $(document).on('click', '[data-bd-toggle="menu"]', function (e){
      e.preventDefault();
      let $target = $($(this).attr('href'));
      if ($target.length) {
        $target.addClass('show');
        $('body').addClass('disable-body');
      }
    })


    $(document).on('click', '[data-bd-toggle="menu"]', function (e){
      e.preventDefault();
      let $target = $($(this).attr('href'));
      if ($target.length) {
        $target.addClass('show');
        $('body').addClass('disable-body');
      }
    })
    return import(/* webpackChunkName: "module-offcanvas-nav" */ './Vendor/hc-offcanvas-nav').then(({default: hcOffcanvasNav}) => {
      return import(/* webpackChunkName: "module-offcanvas-helper" */ './Vendor/hc-offcanvas-nav.helpers').then(() => {

        let nav = new hcOffcanvasNav(selector, {
          disableAt: false,
          // customToggle: '.main-nav-trigger',
          levelTitles: true,
          navTitle: 'Übersicht',
          levelTitleAsBack: true,
          removeOriginalNav: false,
          false: true,
          bodyInsert: 'keep',
          disableBody: false,
        });

        nav.toggle();

      }).catch(err => console.error(err));
    }).catch(err => console.error(err));
  }
}

function initSwiperNewsGallery() {
// init Swiper:
  var swiper = new Swiper(".news-gallery-swiper", {
    // slidesPerView: 2,
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      /*"@0.00": {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      "@0.75": {
        slidesPerView: 2,
        spaceBetween: 20,
      },*/
    }
  });
}

/**
 * initialize layout features and accessibility modal settings
 */
function initAccessibility() {
    triggerAccessibility();

    // form values on accessibility modal have changed
    $(document).on('click', '#modal-accessibility-settings input', function(e) {
        let cookieVal = (this.checked ? 1 : 0);
        if($(this).attr('id') === 'accessibility-settings-fontsize') {
            cookieVal = $(this).val();
        }
        document.cookie = $(this).attr('id') + '=' + cookieVal;
        triggerAccessibility();
    });
}

function triggerAccessibility() {

    let hasAnimationCookie = false;
    const cookieArray = document.cookie.match(/accessibility-settings-[a-z]{0,}=(\d)/g);

    // default font-scale if no cookie-override is present
    setAccessibilityFormVals('accessibility-settings-fontsize', '1');

    for(var i in cookieArray) {
        const keyVal = cookieArray[i].split('=');
        if(keyVal[0] === 'accessibility-settings-animations') {
            hasAnimationCookie = true;
        }
        setAccessibilityFormVals(keyVal[0], keyVal[1]);
        applyAccessibilityFeature(keyVal[0], keyVal[1]);
    }

    // animations should be applied and shown as active when we do not have a cookie value
    if(!hasAnimationCookie) {
        applyAccessibilityFeature('accessibility-settings-animations', '1');
        setAccessibilityFormVals('accessibility-settings-animations', '1');
    }
}

function setAccessibilityFormVals(key, value) {
    if(key === 'accessibility-settings-fontsize') {
        $('#' + key).val(value);
    } else {
        $('#' + key).attr('checked', value === '1');
    }
}

function applyAccessibilityFeature(key, value) {

    switch(key) {

        case 'accessibility-settings-contrast':
            document.querySelectorAll('*:not(input[type=\'checkbox\']):not(.modal-backdrop):not(body):not(html)').forEach(function(entry) {
                if(value === '1') {
                    entry.classList.add('contrastColors');
                } else {
                    entry.classList.remove('contrastColors');
                }
            });

            break;
        case 'accessibility-settings-fontsize':
            const fontSize = value === '1' ? "1rem" : (1 + parseInt(value) * .1) + 'rem';
            $('html').css('font-size', fontSize);
            break;

        case 'accessibility-settings-animations':
            const allSelectors = document.querySelectorAll("footer, h1, h2, h3, h4, h5, p, .card, img, figure, .row, .col, button");
            if(value === '1') {
                window.animationObserver = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            entry.target.classList.remove('invisible');
                            entry.target.classList.add('animationFade');
                        } else {
                            entry.target.classList.remove('animationFade');
                            entry.target.classList.add('invisible');
                        }
                    });
                }, {rootMargin: "0px"});
                allSelectors.forEach(function(entry) {
                    entry.classList.add('invisible');
                    window.animationObserver.observe(entry);
                });
            } else if(typeof window.animationObserver !== 'undefined') {
                window.animationObserver.disconnect();
                allSelectors.forEach(function(entry) {
                    entry.classList.remove('invisible');
                });
            }

            break;
    }

}


/*

var Nav = new hcOffcanvasNav('#main-nav', {
  disableAt: 1024,
  customToggle: '.toggle',
  navTitle: 'All Categories',
  levelTitles: true,
  levelTitleAsBack: true
});*/

//
// Document ready
//



document.addEventListener('DOMContentLoaded', function() {
  initOffCanvasNav('#main-nav');
    initCookieBanner();
    initScrollDownBtn();
    initMenuToggle();
    initSwiperNewsGallery();
    initTabMenu('[data-bs-toggle="pill"]');

    initSearchSuggest();

    initDirectPopups('.modal-direct-popup');
    initAccessibility();

    $(document).on('click', '.modal [data-fancybox]', function() {
        $(this).parents('.modal').first().modal('hide');
    });
});
